import React from 'react';
import './CreateCategory.css';
import profile from '../../images/splash/user.png';
import { useState,useEffect } from 'react';
import axios from 'axios';
import { var_api,image_api } from '../constant';
import Swal from 'sweetalert2';
import { useHistory } from 'react-router-dom';
import Select from 'react-select';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import Layout from '../NewHeader/Layout';
import cimage from '../../images/burger/b1.png';
import Pagination from 'react-js-pagination';


const CreateCategory = () => {
  const history = useHistory();
  const [show, setShow]  = useState(false);
  const [tables, setTables] = useState([]);
  const [shops, setShops] = useState([]);
  const [selectedShop, setSelectedShop] = useState(null);
  const [selectedItemCode, setSelectedItemCode] = useState(null);
  const [ isEdit,setIsEdit ] = useState(false);
  
  const [ isCreate,setCreate ] = useState(false);

  const [ loading, setLoading ] = useState(false);
  const [postloading, setPostloading] = useState(false);
  const ItemCodeOptions = [

    { value: 'Chef', label: 'Chef' },
    { value: 'Captain', label: 'Captain' },
    { value: 'Waiter', label: 'Waiter' },
    // Add more options as needed
  ];
  
  const [DeleteId, setEmployeeD] = useState({});
  const [formData, setFormData] = useState({
    c_name: "",
    c_code: "",
    profile: null,
  });
  const resetForm = () => {
    setFormData({
      c_name: "",
      c_code: "",
      profile: null,
    });
    setCreate(false);
  };
  

const [updateformData, setUpdateFormData] = useState({
  id:null,
  e_name: "", 
  e_email: null, 
  e_password: null,
  e_phone: null,
  e_role: "",
  profile: null,
  shops: []
});
const [isUpdate, setUpdate] = useState(false); // To show/hide update modal
const [updateLoading, setUpdateLoading] = useState(false); // Loading state
const [updateData, setUpdateData] = useState({
  c_name: "",
  c_code: "",
  profile: null,
});
console.log(formData)
const [currentPage, setCurrentPage] = useState(1);
const [itemsPerPage] = useState(10);  // Set your items per page here
const [searchQuery, setSearchQuery] = useState('');

// Function to handle page change
const handlePageChange = (pageNumber) => {
  setCurrentPage(pageNumber);
};

// Function to handle search
const handleSearch = (e) => {
  setSearchQuery(e.target.value);
};

// Filtering tables based on search query
const filteredTables = tables.filter(item =>
  item.category_name.toLowerCase().includes(searchQuery.toLowerCase()) ||
  item.category_code.toLowerCase().includes(searchQuery.toLowerCase())

);

// Logic to slice the filtered tables based on the pagination
const indexOfLastItem = currentPage * itemsPerPage;
const indexOfFirstItem = indexOfLastItem - itemsPerPage;
const currentTables = filteredTables.slice(indexOfFirstItem, indexOfLastItem);

//change the role
  const handleCodeSelectChange = (selectedItem) => {
    console.log("selectedItem",selectedItem)
    const role = selectedItem.value
    setFormData({ ...formData, e_role: role });
  };

  
//change the shop
const handleShopSelectChange = (selectedItem) => {
  console.log("selectedItem",selectedItem)
  const role = selectedItem.value;
  setSelectedShop(role);
  fetchTables(role);
};
const handleSwitchToggle=()=> {
  // Toggle the switch state
  const newStatus = !this.state.imageStatus;
  this.setState({ imageStatus: newStatus });
  // Update localStorage
  localStorage.setItem('image_status', newStatus ? '1' : '0');
  console.log("imagestatus",localStorage.getItem('image_status'));
};
    useEffect(() => {
        fetchTables();
      }, []);


      const fetchTables = async () => {
        setLoading(true);
        const shopId = localStorage.getItem('ShopId')
        try {
           const token = localStorage.getItem('Token')

           const response = await axios.get(`${var_api}category-master/get/${shopId}`,{
            headers:{
              Authorization:`${token}`
            }
           });
           setLoading(false);
           console.log("response",response)
          const user =response.data;
          setTables(user);
          
        } catch (error) {
          setLoading(false);
          setTables([]);
          if (error.response && error.response.status === 401) {
            localStorage.removeItem('Token'); // Clear the invalid token
            history.push('/')// Redirect to the Sign-In page
          } else {
            console.error("Error fetching data:", error);
          }
        }
      };
      

   

      const shopCodeOptions = [
        { value: 0, label: 'All' },
        ...shops.map(shop => ({
          value: shop.id,
          label: shop.shop_name
        }))
      ];
      
      

     //search the transaction data
   




// Handle input changes
const handleInputChange = (e) => {
  const { name, value } = e.target;
  setFormData((prev) => ({ ...prev, [name]: value }));
};

// Handle image change
const handleImageChange = (e) => {
  const file = e.target.files[0];
  setFormData((prev) => ({ ...prev, profile: file }));
};


 // Function to handle checkbox change
 const handleCheckboxChange = (index) => {
  const updatedShops = [...formData.shops];
  const selectedShop = updatedShops[index];
  
  // Toggle is_active property
  updatedShops[index] = {
      ...selectedShop,
      is_active: selectedShop.is_active === 1 ? 0 : 1
  };

  setFormData(prevState => ({
      ...prevState,
      shops: updatedShops
  }));
};


  // Function to capitalize the first letter of a string
  const capitalize = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
   };
  

    // Submit handler
  const Submit = async (e) => {
    e.preventDefault();
    setPostloading(true);

    try {
      // Prepare form data for the API
      const shop_id=localStorage.getItem('ShopId');

      const formDataToSend = new FormData();
      formDataToSend.append("shop_id", shop_id); // Example static shop_id, adjust as needed
      formDataToSend.append("category_name", formData.c_name);
      formDataToSend.append("category_code", formData.c_code);
      formDataToSend.append("category_image", formData.profile);
      formDataToSend.append("is_active", 1); // Example static is_active value
      const token=localStorage.getItem('Token');
      const response = await axios.post(
        `${var_api}category-master/post`, // Replace with your API endpoint
        formDataToSend,
        {
          headers: {
            
          "Content-Type": "multipart/form-data",
          Authorization:`${token}`
        },
        }
      );

      console.log("Category created successfully:", response.data);
      Swal.fire({
        icon: "success",
        title: "Category Created!",
        text: "Category created successfully!.",
        confirmButtonText: "OK",
      });
      // Refresh categories table
      fetchTables();

      // Reset form
      setFormData({ c_name: "", c_code: "", profile: null });

      // Close the modal
      setCreate(false);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.removeItem('Token'); // Clear the invalid token
        history.push('/')// Redirect to the Sign-In page
      } else {
        console.error("Error fetching data:", error);
      }
      Swal.fire({
        icon: "error",
        title: "Error",
        text:`${error.response.data.error}`,

        confirmButtonText: "OK",
      });
    } finally {
      setPostloading(false);
    }
  };


    //reset the values
    const handleToReset = () => {
         // Reset the form fields individually
         setFormData({
          ...formData,
          e_name: " ", 
  e_email: "", 
  e_password:" ",
  e_phone:"",
  e_role:"",
  profile:null
      });
    }

    //Go to home page
    const handleButtonClick = () => {
      history.push('/AdminHome')
    }


    //get the value in search and set the setstate
    const handleSearchInput = (e) => {
      setSearchQuery(e.target.value)
      };


      

     //delete method for remove UOM
 
     //delete method for remove UOM
     const handleDeleteEmployeee = (id) => {
      setEmployeeD({id});
      setShow(true);
    };

    //delete the employeee
    const handleDelete = () => {
      const token=localStorage.getItem('Token');
      axios.delete(`${var_api}category-master/delete/${DeleteId.id}`,{
        headers:{
          Authorization:`${token}`
        }
      }
      )
        .then((response) => {
          if (response.status === 200) {
            fetchTables(); // Refresh the employee list
            setShow(false);
            Swal.fire("Success", "Category removed successfully!", "success");
          } else if (response.status === 404) {
            console.error("Employee not found");
          }
        })
        .catch((error) => {
          if (error.response && error.response.status === 401) {
            localStorage.removeItem('Token'); // Clear the invalid token
            history.push('/')// Redirect to the Sign-In page
          } else {
            console.error("Error fetching data:", error);
          }
          Swal.fire("Error", `${error.response.data.message}`, "error");
        });
    };




    //Function for open the update modal
    const handleUpdateEmployee = () =>{
      setIsEdit(true);
    //   console.log("data",data)
    //   setUpdateFormData({
    //       id:data.id,
    //       e_name: data.e_name, 
    //       e_email: data.e_email, 
    //       e_password: data.e_password,
    //       e_phone: data.e_phone,
    //       e_role: data.e_role,
    //       profile: data.e_profile,
    //       shops: data.shops
    //   })
    }
    const handleCreateEmployee = () =>{
      setCreate(true);
    }
    //Function for update text field onchange
const handleInputUpdateChange = (e) => {
  const { name, value } = e.target;
  setUpdateFormData({ ...updateformData, [name]: value });
};


//Oncahnge function for update role
const handleRoleUpdateChange = (selectedOption) => {
  console.log("hjdahj",selectedOption.value)
  setUpdateFormData({ ...updateformData, e_role: selectedOption.value});
};

//onchange function for file 
const handleImageUpdateChange = (e) => {
  const file = e.target.files[0];
  console.log("file",file)
  setUpdateFormData({ ...updateformData, profile: file });
};


 // Function to handle update checkbox change
 const handleUpdateCheckboxChange = (index) => {
  const updatedShops = [...updateformData.shops];
  const selectedShop = updatedShops[index];
  
  // Toggle is_active property
  updatedShops[index] = {
      ...selectedShop,
      is_active: selectedShop.is_active === 1 ? 0 : 1
  };
  console.log("upd",updatedShops);

  setUpdateFormData(prevState => ({
      ...prevState,
      shops: updatedShops
  }));
};


//update method for employee
//post method for updating the food

  const handleToggle = (isChecked, item) => {
    const formData = new FormData();
formData.append('shop_id', item.shop_id);
formData.append('category_name', item.category_name);
formData.append('category_code', item.category_code);
formData.append('is_active', isChecked ? 1 : 0);
formData.append('is_manual', item.is_manual);
formData.append('is_billing', item.is_billing);
formData.append('category_image', item.category_image); // File from input


    // const updatedData = {
    //   shop_id: item.shop_id,
    //   category_name: item.category_name,
    //   category_image: item.category_image,

    //   category_code: item.category_code,
    //   is_active: isChecked ? 1 : 0, // Convert boolean to 1 or 0
    // };
    const token=localStorage.getItem('Token');
    axios
      .put(`${var_api}category-master/put/${item.id}`, formData,{
        headers:{
          Authorization:`${token}`
        }}
      )
      .then((response) => {
        if (response.status === 200) {
          Swal.fire("Success", "Category status updated successfully!", "success");
            fetchTables();
       
        } else {
          Swal.fire("Error", "Failed to update category status!", "error");
        }
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          localStorage.removeItem('Token'); // Clear the invalid token
          history.push('/')// Redirect to the Sign-In page
        } else {
          console.error("Error updating data:", error);
        }
        Swal.fire("Error", "An error occurred while updating!", "error");
      });
  };


  //update is_manual toggle
   const handleManualToggle = (isChecked, item) => {
    const formData = new FormData();
formData.append('shop_id', item.shop_id);
formData.append('category_name', item.category_name);
formData.append('category_code', item.category_code);
formData.append('is_manual', isChecked ? 1 : 0);
formData.append('is_active', item.is_active);
formData.append('is_billing', item.is_billing);
formData.append('category_image', item.category_image); // File from input


    // const updatedData = {
    //   shop_id: item.shop_id,
    //   category_name: item.category_name,
    //   category_image: item.category_image,

    //   category_code: item.category_code,
    //   is_active: isChecked ? 1 : 0, // Convert boolean to 1 or 0
    // };
    const token=localStorage.getItem('Token');
    axios
      .put(`${var_api}category-master/put/${item.id}`, formData,{
        headers:{
          Authorization:`${token}`
        }}
      )
      .then((response) => {
        if (response.status === 200) {
          Swal.fire("Success", "Category status updated successfully!", "success");
            fetchTables();
       
        } else {
          Swal.fire("Error", "Failed to update category status!", "error");
        }
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          localStorage.removeItem('Token'); // Clear the invalid token
          history.push('/')// Redirect to the Sign-In page
        } else {
          console.error("Error updating data:", error);
        }
        Swal.fire("Error", "An error occurred while updating!", "error");
      });
  };


  //update billing toggle
  const handleBillingToggle = (isChecked, item) => {
    const formData = new FormData();
formData.append('shop_id', item.shop_id);
formData.append('category_name', item.category_name);
formData.append('category_code', item.category_code);
formData.append('is_billing', isChecked ? 1 : 0);
formData.append('is_manual', item.is_manual);
formData.append('is_active', item.is_active);
formData.append('category_image', item.category_image); // File from input


    // const updatedData = {
    //   shop_id: item.shop_id,
    //   category_name: item.category_name,
    //   category_image: item.category_image,

    //   category_code: item.category_code,
    //   is_active: isChecked ? 1 : 0, // Convert boolean to 1 or 0
    // };
    const token=localStorage.getItem('Token');
    axios
      .put(`${var_api}category-master/put/${item.id}`, formData,{
        headers:{
          Authorization:`${token}`
        }}
      )
      .then((response) => {
        if (response.status === 200) {
          Swal.fire("Success", "Category status updated successfully!", "success");
            fetchTables();
       
        } else {
          Swal.fire("Error", "Failed to update category status!", "error");
        }
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          localStorage.removeItem('Token'); // Clear the invalid token
          history.push('/')// Redirect to the Sign-In page
        } else {
          console.error("Error updating data:", error);
        }
        Swal.fire("Error", "An error occurred while updating!", "error");
      });
  };



  const handleEditCategory = (category) => {
    setUpdateData({
      c_name: category.category_name,
      c_code: category.category_code,
      profile: category.category_image,
      id: category.id,
      is_active: category.is_active,
      shop_id: category.shop_id,
      is_manual: category.is_manual 

    });
    setUpdate(true);
  };
  const handleUpdateInputChange = (e) => {
    const { name, value } = e.target;
    setUpdateData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  
  const handleUpdateImageChange = (e) => {
    const file = e.target.files[0];
    setUpdateData((prevData) => ({
      ...prevData,
      profile: file,
    }));
  };
  const updateCategory = (e) => {
    e.preventDefault();
    setUpdateLoading(true);
  
    const formData = new FormData();
    formData.append("category_name", updateData.c_name);
    formData.append("is_active", updateData.is_active);
    formData.append("shop_id", updateData.shop_id);
    formData.append("is_manual", updateData.is_manual);
    formData.append("category_code", updateData.c_code);
    formData.append("category_image", updateData.profile);
  
    const token = localStorage.getItem("Token");
  
    axios
      .put(`${var_api}category-master/put/${updateData.id}`, formData, {
        headers: {
          Authorization: `${token}`,
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        if (response.status === 200) {
          fetchTables(); // Refresh table data
          Swal.fire("Success", "Category updated successfully!", "success");
          setUpdate(false);
        } else {
          Swal.fire("Error", "Failed to update category!", "error");
        }
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          localStorage.removeItem('Token'); // Clear the invalid token
          history.push('/')// Redirect to the Sign-In page
        } else {
          console.error("Error updating category:", error);
        }
        Swal.fire("Error", `${error.response.data.error}`, "error");
      })
      .finally(() => {
        setUpdateLoading(false);
      });
  };




    return(
      <>         <Layout>

       

            <div class="splitcc">
          
      <div style={{border:"none",padding:"15px",width:"105%",minHeight:"630px",margin:"auto",borderRadius:"10px",backgroundColor:"white",boxShadow:" rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 56px, rgba(17, 17, 26, 0.1) 0px 24px 80px"}}>
    
      <Button variant='dark'className='mb-4' onClick={handleCreateEmployee}   style={{fontSize:"14px",float:"right",borderRadius:"10px", marginLeft:"10px"}}>Create Category</Button>{' '}
      
      <div>

       <div class="row">
         <div class="col">
<h4 className='ushe'>CREATE CATEGORY</h4>
         </div>
         <div class="col">
         <input class="form-control" type="Search" placeholder="Search" id="example-search-input" 
    style={{width:"230px",borderRadius:"10px",border:"1px solid black",float:"right"}} onChange={handleSearchInput}/>
         </div>
        
       </div>
    <br/>
      <div className="table-container" style={{ maxHeight:"540px", overflowX: 'auto', overflowY: 'scroll' }}>
     <table class="table table-hover small-first-col" style={{border:"none",borderColor:"grey",width:"90%",margin:"auto"}}>
  <thead>
    <tr style={{fontWeight:"bolder"}}>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">S.No</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Image</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Name</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Code</th>

      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Status</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Is Manual</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Is Billing</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Action</th>
    </tr>
  </thead>
  {loading ? (
  <div className="loader-containeru">
    <div className="spinneru"></div>
  </div>
) : currentTables.length > 0 ? (
  <tbody className="body-half-screen">
    {currentTables.map((item, index) => (
      <tr style={{ padding: "7px" }} key={index}>
        <th scope="row" style={{ textTransform: "capitalize", textAlign: "left" }}>
          {indexOfFirstItem + index + 1}
        </th>
        <td style={{ textTransform: "capitalize", textAlign: "left" }}>
          <img
            src={`${image_api}/${item.category_image}`}
            alt="profile"
            style={{ width: '75px', height: '65px', objectFit: 'cover' }}
          />
        </td>
        <td style={{ textTransform: "capitalize", textAlign: "left" }}>
          {item.category_name}
        </td>
        <td style={{ textTransform: "capitalize", textAlign: "left" }}>
          {item.category_code}
        </td>
        <td style={{ textAlign: "left" }}>
          <div
            className="form-check form-switch"
            style={{ display: "flex", justifyContent: "left" }}
          >
            <input
              className="form-check-input"
              type="checkbox"
              role="switch"
              checked={item.is_active == 1} // Checkbox is checked if is_active is 1
              onChange={(e) => handleToggle(e.target.checked, item)}
            />
          </div>
        </td>
        <td style={{ textAlign: "left" }}>
          <div
            className="form-check form-switch"
            style={{ display: "flex", justifyContent: "left" }}
          >
            <input
              className="form-check-input"
              type="checkbox"
              role="switch"
              checked={item.is_manual == 1} // Checkbox is checked if is_active is 1
              onChange={(e) => handleManualToggle(e.target.checked, item)}
            />
          </div>
        </td>
         <td style={{ textAlign: "left" }}>
          <div
            className="form-check form-switch"
            style={{ display: "flex", justifyContent: "left" }}
          >
            <input
              className="form-check-input"
              type="checkbox"
              role="switch"
              checked={item.is_billing == 1} // Checkbox is checked if is_active is 1
              onChange={(e) => handleBillingToggle(e.target.checked, item)}
            />
          </div>
        </td>
        <td style={{ textAlign: "left" }}>
          <i
            className="bi bi-pencil-square"
            onClick={() => handleEditCategory(item)}
            style={{ fontSize: "20px", color: "rgb(9, 97, 9)" }}
          ></i>{" "}
          <i
            className="bi bi-trash"
            onClick={() => handleDeleteEmployeee(item.id)}
            style={{ fontSize: "21px", color: "rgb(175, 2, 2)" }}
          ></i>
        </td>
      </tr>
    ))}
  </tbody>
) : (
  <tbody className="body-half-screen">
    <tr>
      <td colSpan="6" style={{ textAlign: "center", color: "gray" }}>
        No Data Available
      </td>
    </tr>
  </tbody>
)}

</table>
<Pagination
        activePage={currentPage}
        itemsCountPerPage={itemsPerPage}
        totalItemsCount={filteredTables.length}  // Use filteredTables length
        pageRangeDisplayed={5}
        onChange={handlePageChange}
        itemClass="page-item"
        linkClass="page-link"
        innerClass="pagination justify-content-end"
        activeClass="active-pagination"
      />

      </div>
      

</div>
        </div>
      
      </div>

      <Modal
        show={show}
        onHide={()=>setShow(false)}
        backdrop="static"
        keyboard={false}
        size="md" // Set size to large
      >
        <Modal.Header style={{padding:"3px", backgroundColor:"green"}}>
          <Modal.Title style={{ fontSize:"20px"}}></Modal.Title>
        </Modal.Header>
        <Modal.Body>

         <div style={{padding:"20px"}}>
         {/* <h4 style={{fontFamily:"monospace",fontWeight:"bolder",textAlign:"center"}}>CONFIRM !</h4> */}
          <h6 className='text-dark' style={{textAlign:"center",fontWeight:"bolder"}}>Are You Sure want to Delete Category Name 
          <span style={{color:"red",textTransform:"uppercase"}}> </span> ?</h6> 
         </div>
         {' '} 
          <Button variant="danger" style={{float:"right"}} onClick={()=>setShow(false)}>
            Close
          </Button>{' '} 
          <Button variant="success" style={{float:"right",marginRight:"5px"}} onClick={handleDelete}>
            Confirm
          </Button>
        </Modal.Body>
        {/* <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseConfirmation}>
            Close
          </Button>
        </Modal.Footer> */}
      </Modal>

      <Modal
  show={isUpdate} // State to control the visibility of the update modal
  onHide={() => setUpdate(false)}
  backdrop="static"
  keyboard={false}
  size="lg"
>
  <Modal.Header closeButton>
    <Modal.Title>Update Category</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <form className="py-2" onSubmit={updateCategory}>
      <div className="row">
        <div className="col">
          <label
            htmlFor="updateName"
            style={{ color: "green", fontFamily: "serif", fontWeight: "bolder" }}
          >
            Category Name
          </label>
          <input
            type="text"
            className="form-control"
            placeholder="Category Name"
            name="c_name"
            value={updateData.c_name}
            onChange={handleUpdateInputChange}
            style={{ borderRadius: "10px", height: "50px" }}
            required
          />
        </div>
        <div className="col">
          <label
            htmlFor="updateCode"
            style={{ color: "green", fontFamily: "serif", fontWeight: "bolder" }}
          >
            Category Code
          </label>
          <input
            type="text"
            className="form-control"
            placeholder="Category Code"
            name="c_code"
            value={updateData.c_code}
            onChange={handleUpdateInputChange}
            style={{ borderRadius: "10px", height: "50px" }}
            required
          />
        </div>
      </div>
      <br />
      <div className="row">
        <div className="col">
          <label
            htmlFor="updateImage"
            style={{ color: "green", fontFamily: "serif", fontWeight: "bolder" }}
          >
            Category Image
          </label>
          <input
            type="file"
            className="form-control"
            onChange={handleUpdateImageChange}
            style={{ borderRadius: "10px", height: "50px" }}
          />
        </div>
      </div>
      <br />
      <div className="text-center">
        {updateLoading ? (
          <Spinner
            as="span"
            animation="border"
            size="sm"
            role="status"
            aria-hidden="true"
          />
        ) : (
          <button
            className="btn btn-success"
            style={{ borderRadius: "10px", float: "right", marginTop: "6px" }}
            disabled={updateLoading}
          >
            Update
          </button>
        )}
      </div>
    </form>
    <button
      className="btn btn-danger"
      onClick={() => setUpdate(false)}
      style={{ borderRadius: "10px", float: "right", marginRight: "5px" }}
    >
      Cancel
    </button>
  </Modal.Body>
</Modal>


      <Modal
      show={isCreate}
      onHide={() => setCreate(false)}
      backdrop="static"
      keyboard={false}
      size="lg"
    >
      <Modal.Header closeButton>
        <Modal.Title>Create Category</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form className="py-2" onSubmit={Submit}>
          <div className="row">
            <div className="col">
              <label
                htmlFor="input1"
                style={{ color: "green", fontFamily: "serif", fontWeight: "bolder" }}
              >
                Category Name
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="Category Name"
                name="c_name"
                value={formData.c_name}
                onChange={handleInputChange}
                style={{ borderRadius: "10px", height: "50px" }}
                required
              />
            </div>
            <div className="col">
              <label
                htmlFor="input2"
                style={{ color: "green", fontFamily: "serif", fontWeight: "bolder" }}
              >
                Category Code
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="Category Code"
                name="c_code"
                value={formData.c_code}
                onChange={handleInputChange}
                style={{ borderRadius: "10px", height: "50px" }}
                required
              />
            </div>
          </div>
          <br />
          <div className="row">
            <div className="col">
              <label
                htmlFor="input5"
                style={{ color: "green", fontFamily: "serif", fontWeight: "bolder" }}
              >
                Category Image
              </label>
              <input
                type="file"
                className="form-control"
                onChange={handleImageChange}
                name="profile"
                style={{ borderRadius: "10px", height: "50px" }}
              />
            </div>
          </div>
          <br />
          <div className="text-center">
            {postloading ? (
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />
            ) : (
              <button
                className="btn btn-success"
                style={{ borderRadius: "10px", float: "right", marginTop: "6px" }}
                disabled={postloading}
              >
                Create
              </button>
            )}
          </div>
        </form>
        <button
          className="btn btn-danger"
          onClick={() => resetForm()}
          style={{ borderRadius: "10px", float: "right", marginRight: "5px" }}
        >
          Cancel
        </button>
      </Modal.Body>
    </Modal>


            {/* </div> */}
       </Layout></>

        
    )
}

export default CreateCategory;